import angular from "angular";
import "ngstorage";
import "ngmap";
import IterableService from "../../services/iterable.js";
import zip from "../../services/validation/zip";

class JobsController {
  constructor(
    $window,
    $location,
    $http,
    $localStorage,
    $state,
    AuthService,
    EventsService,
    SecurityService,
    $stateParams,
    $timeout,
    $interval,
    $rootScope,
    $scope,
    JobService,
    $anchorScroll,
    TrackingService,
    ProfileService,
    IterableService,
    analytics
  ) {
    this.name = "jobs";
    $localStorage.activeStateName = "jobs";

    this.$window = $window;
    this.$location = $location;
    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$auth = AuthService;
    this.$events = EventsService;
    this.$jobs = JobService;
    this.$security = SecurityService;
    this.$stateParams = $stateParams;
    this.$tracking = TrackingService;
    this.$iterable = IterableService;
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;
    this.$profile = ProfileService;
    this.$analytics = analytics;
    this.$interval = $interval;
    this.$scope = $scope;

    this.currentUser = this.$auth.getUserData();
    this.bottom_loading = false;
    this.jobs_loading = true;
    this.userReady = false;
    this.boardParams = {
      sort: {
        name: "startTime",
        value: "asc",
      },
      max: 10,
    };

    this.filter = {
      zip_change: false,
      radius_change: false,
      sort_change: false,
    };

    this.filters = {
      companies: [],
    };

    this.sort = "startTime";

    this.no_more_jobs_with_this_search = false;
    this.no_zip_code = false;

    if (!this.$rootScope.jobsSeenOnce) {
      this.$timeout(() => {
        this.$rootScope.$emit("SetLoaderDialog", {
          type: 15,
          total: 1,
        });
      });
    }

    // Checks if the user is able to apply to jobs
    if (this.currentUser) {
      if (this.currentUser.company && this.currentUser.company.id) {
        this.$state.go("jobsdashboard");
      }
      this.canUserApplyToShiftBasedJobs();
    }

    this.SetSearchRadiusListener = this.$rootScope.$on("SetSearchRadius", ($event, params) => {
      this.$timeout(() => {
        const queryParams = this.boardParams;

        queryParams.offset = 0;
        queryParams.geoFenceRadius = this.$jobs.milesToKilometers(parseFloat(params));

        this.formatAndSyncQueryParams(queryParams);

        if (queryParams.zipcode) this.loadJobsPOST(queryParams);
      });
    });

    this.SetCompanyFiltersListener = this.$rootScope.$on("SetCompanyFilters", ($event, params) => {
      this.$timeout(() => {
        this.filters.companies = params;
        this.applyFilters(this.jobs);

        if (this.selectedJob && this.filteredJobs) {
          let found = false;
          this.filteredJobs.forEach((job) => {
            if (job.id === this.selectedJob.id) found = true;
          });

          if (!found) this.setSelectedJob(this.filteredJobs[0]);
        }
      });
    });

    this.SetLocationFiltersListener = this.$rootScope.$on("SetLocationFilters", ($event, params) => {
      this.$timeout(() => {
        this.filters.locations = params;
        this.applyFilters(this.jobs);

        if (this.selectedJob && this.filteredJobs) {
          let found = false;
          this.filteredJobs.forEach((job) => {
            if (job.id === this.selectedJob.id) found = true;
          });

          if (!found) this.setSelectedJob(this.filteredJobs[0]);
        }
      });
    });

    this.CityStateSearchListener = this.$rootScope.$on("CityStateSearch", ($event, params) => {
      this.$timeout(() => {
        this.searchLocation = `${params.city}, ${params.state}`;
      });
    });

    this.UserHasConfirmedTheirEmailListener = this.$rootScope.$on("UserHasConfirmedTheirEmail", ($event, params) => {
      this.closeVerificationModal();
    });

    this.SetNewUserForJobBoardListener = this.$rootScope.$on("SetNewUserForJobBoard", ($event, params) => {
      this.currentUser = params.user;
      this.$timeout(() => {
        this.canUserApplyToShiftBasedJobs();
      }, 100);
    });

    this.SendSearchParcelListener = this.$rootScope.$on("SendSearchParcel", ($event, params) => {
      if (params) {
        let queryParams = this.boardParams;

        queryParams.offset = 0;

        if (params.zipcode) {
          queryParams.zipcode = params.zipcode;
        }

        queryParams.search = params.query;

        if (params.type) {
          queryParams.type = params.type;
        }

        console.log("from new parcel", queryParams);

        this.$timeout(() => {
          this.loadJobs(queryParams).then((queryParams) => {
            this.loadJobsPOST(queryParams);
          });
        });
      }
    });

    this.$scope.$on("$destroy", this.UserHasConfirmedTheirEmailListener);
    this.$scope.$on("$destroy", this.SetNewUserForJobBoardListener);
    this.$scope.$on("$destroy", this.SendSearchParcelListener);
    this.$scope.$on("$destroy", this.SetSearchRadiusListener);
    this.$scope.$on("$destroy", this.SetCompanyFiltersListener);
    this.$scope.$on("$destroy", this.SetLocationFiltersListener);
    this.$scope.$on("$destroy", this.CityStateSearchListener);

    this.setJobbleTypes = this.setJobbleTypes.bind(this);
    this.setJobForBackButton = this.setJobForBackButton.bind(this);
    this.applyToJobble = this.applyToJobble.bind(this);
    this.trackApplyToJobFromBoard = this.trackApplyToJobFromBoard.bind(this);
  }

  handleNoJobble(error) {
    if (error.data.codeDescription === "openingDeletedButJobStillOpen") {
      this.$location.search("rjid", error.data.details[0].availableJob);
      this.$onInit();
    }
  }

  getCurrentUserData() {
    if (this.currentUser) {
      this.$auth.refreshCurrentUser().then(() => {
        this.getMostRecentUser((user) => {
          this.$timeout(() => {
            this.currentUser = user || this.currentUser;
          });
        });
      });
    }
  }

  getMostRecentUser() {
    return new Promise((resolve, reject) => {
      resolve(this.$auth.getUserData());
    });
  }

  $onInit() {
    console.log("$onInit");
    console.dir(this.$location);
    console.dir(this.currentUser);
    this.getCurrentUserData();

    if (this.$location.$$search.rjid) {
      this.$timeout(() => {
        this.hasInitialSelectedJob = true;
      });

      console.time("Loading single job");
      const jobble_id = this.$location.$$search.rjid;
      this.$location.search("rjid", undefined);

      console.log("Loading jobble id:", jobble_id);

      this.$jobs.getJob(jobble_id).then(
        (response) => {
          console.timeEnd("Loading single job");
          console.dir(response.data);

          let temp = response.data;

          if (_.isEmpty(response.data) || response.data.status === "error") {
            this.hasInitialSelectedJob = false;
            this.setInitialParams().then((params) => {
              if (params && params.zipcode) {
                this.loadJobs(params).then((queryParams) => {
                  this.loadJobsPOST(queryParams);
                });
              }
            });
            return console.error("EMPTY JOB");
          }

          this.$timeout(() => {
            this.setSelectedJob(this.$jobs.processJob(response.data).job);
            this.setSelectedMobileJob(this.$jobs.processJob(response.data).job);

            if (this.$location.$$search.o && parseFloat(this.$location.$$search.o) === 1 && this.currentUser && !this.selectedJob.is_partner_post) {
              this.$location.search("o", undefined);
              this.applyToJobble(this.selectedJob);
            }

            const params = {
              zipcode: this.selectedJob.subEvent.contactInfo.zipCode,
            };

            this.loadJobs(params).then((queryParams) => {
              this.loadJobsPOST(queryParams);
            });
          });
        },
        (error) => {
          this.handleNoJobble(error);
        }
      );
    } else {
      if (this.$location.$$search.jid) {
        this.hasInitialSelectedJob = true;

        console.time("Loading single job");
        const jobble_id = this.$location.$$search.jid;

        console.log("Loading jobble id:", jobble_id);

        this.$jobs.getJob(jobble_id).then((response) => {
          console.timeEnd("Loading single job");

          if (_.isEmpty(response.data) || response.data.status === "error") {
            this.hasInitialSelectedJob = false;
            return;
          }

          console.log(response.data);

          this.setSelectedJob(this.$jobs.processJob(response.data).job);

          if (!this.boardParams.zipcode && !this.$location.$$search.z) {
            let params = {
              zipcode: this.selectedJob.subEvent.contactInfo.zipCode,
            };

            this.loadJobs(params).then((queryParams) => {
              this.loadJobsPOST(queryParams);
            });
          } else {
            let params = {
              zipcode: this.$location.$$search.z,
            };

            this.loadJobs(params).then((queryParams) => {
              this.loadJobsPOST(queryParams);
            });
          }
        });
      } else {
        this.setInitialParams().then((params) => {
          if (params && params.zipcode) {
            this.loadJobs(params).then((queryParams) => {
              this.loadJobsPOST(queryParams);
            });
          }
        });
      }
    }
  }

  setScrollListener() {
    const scroller = document.getElementById("job-scroll");
    const scrollContent = document.getElementById("job-inner-scroll");

    if (!scroller)
      return this.$timeout(() => {
        this.setScrollListener();
      }, 500);

    scroller.onscroll = () => {
      const position = scroller.clientHeight + scroller.scrollTop;
      const buffer = 0.2;

      const distance = (scrollContent.clientHeight - position) / scrollContent.clientHeight;
      // console.log("SCROLL DISTANCE:", distance);

      if (distance < buffer) {
        this.loadMoreJobs();
      }
    };
  }

  setSelectedMobileJob(job) {
    if (!job) {
      this.selectedJobMobile = null;
      document.body.style.position = "";
      document.body.style.top = ``;
      this.$location.search("mjid", null);
    } else {
      this.selectedJobMobile = job;
      this.selectedJob = job;
      document.body.style.position = "fixed";
      document.body.style.top = `-${window.scrollY}px`;
      this.$location.search("mjid", job.id);
    }
  }

  setSelectedJob(job) {
    if (!job) {
      this.selectedJob = null;
      this.$location.search("jid", null);
    } else {
      this.selectedJob = job;
      this.$location.search("jid", job.id);
    }
  }

  setJobbleTypes(jobbleTypeNames) {
    this.jobs_loading = true;
    const queryParams = this.boardParams;

    queryParams.offset = 0;

    queryParams.jobbleTypeNames = jobbleTypeNames;

    this.formatAndSyncQueryParams(queryParams);

    if (queryParams.zipcode) this.loadJobsPOST(queryParams);
  }

  applyFilters(jobs) {
    this.filteredJobs = jobs;

    if (this.filters) {
      if (this.filters && this.filters.companies && this.filters.companies.length) {
        this.filteredJobs = this.filteredJobs.filter((job) => {
          return this.filters.companies.indexOf(job.companyName) !== -1;
        });
      }
      if (this.filters && this.filters.locations && this.filters.locations.length) {
        this.filteredJobs = this.filteredJobs.filter((job) => {
          let l = "";

          if (job.is_partner_post) {
            l = `${job.city}, ${job.state}`;
          } else {
            l = `${job.subEvent.contactInfo.city}, ${job.subEvent.contactInfo.state}`;
          }

          return this.filters.locations.indexOf(l) !== -1;
        });
      }
    } else {
    }

    this.filteredRelevantJobs = this.filteredJobs.filter((job) => !job.isFillInPost);
    this.filteredFillInJobs = this.filteredJobs.filter((job) => job.isFillInPost);

    this.setScrollListener();
  }

  processJobs(jobs, loadingMore) {
    console.log("processJobs");
    console.dir(jobs);

    return new Promise((resolve) => {
      //console.log("process jobs");
      //console.dir(jobs);

      if (!this.jobs || !loadingMore) {
        //console.log("are we starting fresh");
        this.jobs = [];
        this.relevantJobs = [];
        this.fillInJobs = [];
        this.filteredJobs = [];
        this.filteredRelevantJobs = [];
        this.filteredFillInJobs = [];
        this.$rootScope.jobs = [];
        this.jobs_loading = false;
      }

      try {
        jobs.map((job) => {
          this.jobs.push(this.$jobs.processJob(job).job);
        });

        this.relevantJobs = this.jobs.filter((job) => !job.isFillInPost);
        this.fillInJobs = this.jobs.filter((job) => job.isFillInPost);
      } catch (err) {
        console.log("error in process jobs");
        console.dir(err);
      } finally {
        this.jobs_loading = false;

        let c = {};
        let l = {};
        this.jobs.forEach((job) => {
          c[job.companyName] = 1;

          if (job.is_partner_post) {
            l[`${job.city}, ${job.state}`] = 1;
          } else {
            l[`${job.contactInfo.city}, ${job.contactInfo.state}`] = 1;
          }

          job.overnight = this.checkForOvernight(job);

          job.shifts.forEach(function (s) {
            let start = new Date(s.timeInterval.startTime);
            let end = new Date(s.timeInterval.endTime);

            let startMoment = moment(start);
            let endMoment = moment(end);

            if (startMoment.isDST() === false && moment().isDST() === true) {
              startMoment.add(1, "hours");
              endMoment.add(1, "hours");
            } else if (startMoment.isDST() === true && moment().isDST() === false) {
              startMoment.subtract(1, "hours");
              endMoment.subtract(1, "hours");
            }

            let timeZone = s.contactInfo.place.timeZoneId;
            //let timeZone = "America/New_York";
            let startDay = startMoment.tz(timeZone).format("M/DD");

            const diffTime = endMoment.tz(timeZone).diff(startMoment.tz(timeZone));
            const durTime = moment.duration(diffTime);

            const durHours = durTime.hours();
            const durMin = durTime.minutes();

            let unpaidBreaks = s.unpaidBreak;

            const durationInMinutes = durHours * 60 + durMin;
            const payableMinutes = durationInMinutes - unpaidBreaks;

            s.payableHours = Math.floor(payableMinutes / 60);
            s.payableMins = payableMinutes % 60;
          });

          this.setTotalHoursToJob(job);
        });

        let companies = Object.keys(c);
        let locations = Object.keys(l);

        this.$rootScope.$emit("SetJobSearchCompanies", companies);
        this.$rootScope.$emit("SetJobSearchLocations", locations);

        console.log("this.jobs");
        console.dir(this.jobs);

        resolve(this.jobs);

        this.isCurrentUser();
      }
    });
  }

  setTotalHoursToJob(job) {
    let shifts = job.shifts;
    let totalHours = 0;
    let totalMinutes = 0;

    shifts.forEach(function (shift) {
      totalHours = shift.payableHours + totalHours;
      totalMinutes = shift.payableMins + totalMinutes;
    });

    totalHours = totalHours + totalMinutes / 60;
    job.totalPayableHours = totalHours;
    job.estimatedTotalPayables = job.jobblerRate * job.totalPayableHours;
  }

  checkForOvernight(job) {
    let result;

    let s = job.shifts.find((o) => o.overnight === true);

    if (s) {
      result = true;
    } else {
      result = false;
    }

    return result;
  }

  getCoordinates() {
    let coords = {};
    this.setLoader();

    return new Promise((resolve, reject) => {
      this.$window.navigator.geolocation.getCurrentPosition(
        (position) => {
          coords.lat = position.coords.latitude;
          coords.lng = position.coords.longitude;
          this.unSetLoader();
          return resolve(coords);
        },
        (error) => {
          console.error(error);
          this.unSetLoader();
          reject(error);
        }
      );
    });
  }

  getZipFromGeocoder(coords) {
    if (!window.google) {
      alert("Google never loaded");
      return;
    }
    let geocoder = new window.google.maps.Geocoder();

    console.log("getZipFromGeocoder");

    let zipCode;

    return new Promise((resolve, reject) => {
      geocoder.geocode(
        {latLng: coords},
        (results, status) => {
          if (status == window.google.maps.GeocoderStatus.OK) {
            if (results[0]) {
              for (var j = 0; j < results[0].address_components.length; j++) {
                if (results[0].address_components[j].types[0] == "postal_code") {
                  zipCode = results[0].address_components[j].short_name;
                }
              }

              resolve(zipCode);
            }
          } else {
          }
        },
        (error) => {}
      );
    });
  }

  placeParamsInURL(params) {
    this.$location.search("ref", params.placeRef);
    this.$location.search("z", params.zip || params.zipcode || params.zip_code);
    this.$location.search("q", params.search);
    this.$location.search("t", params.type);
  }

  setInitialParams() {
    return new Promise((resolve, reject) => {
      const queryParams = this.setJobParamsForSearch();

      this.$timeout(() => {
        this.formatAndSyncQueryParams(queryParams);
      });

      if (queryParams.zipcode) {
        return resolve(queryParams);
      } else {
        try {
          this.$timeout(() => {
            this.getCoordinates()
              .then((coords) => {
                this.setLoader();
                this.$jobs.awaitForGoogleToLoad(coords).then(() => {
                  this.getZipFromGeocoder(coords).then((zipCode) => {
                    console.log("zipCode rectired from thing", zipCode);
                    queryParams.zipcode = zipCode;
                    resolve(queryParams);
                  });
                });
              })
              .catch((err) => {
                resolve(queryParams, {});
                this.$timeout(() => {
                  this.no_zip_code = true;
                });
              });
          });
        } catch (err) {
          console.error(err);
        } finally {
          if (!queryParams.zipcode) {
            this.no_zip_code = true;
          }
        }
        this.$rootScope.jobsSeenOnce = true;
      }
    });
  }

  loadJobs(queryParams) {
    if (queryParams.zipcode) {
      this.$localStorage.zipCode = queryParams.zipcode;
    }

    return new Promise((resolve, reject) => {
      this.$jobs.getPlaceRef(queryParams).then(
        (response) => {
          if (response.data.length === 0) {
            alert("This zipcode does not exist");
            return reject();
          }

          queryParams.lat = response.data[0].lat;
          queryParams.lng = response.data[0].lng;
          queryParams.placeRef = response.data[0].id;

          resolve(queryParams);
        },
        (error) => {
          console.error(error);
          this.system_error = true;
          reject();
        }
      );
    });
  }

  applyToJobble(job, x, type) {
    console.log("Applying to job");
    console.log(job, x, type);

    this.$rootScope.$emit("SetApplyProfileJob", {job});

    if (x) {
      this.trackViewJobFromBoard(job);
    } else {
      this.trackApplyToJobFromBoard(job);
    }

    console.log("Determining type");

    if (
      job.is_partner_post ||
      (job.isSourcingPost && !this.currentUser) ||
      (job.isSourcingPost && this.currentUser) ||
      (!job.isSourcingPost && this.userReady && !job.urlToApply) ||
      (job.is_partner_post && !this.currentUser)
    ) {
      if (job.companyName === "Uber" || job.is_partner_post) {
        console.log("Send to partner post url");
        this.sendToPartnerPostUrl(job, type);
      } else {
        console.log("Get ready to apply");
        this.getQuestionsReadyForApply(job);
      }
    } else if (!job.isSourcingPost && !this.userReady && !job.urlToApply) {
      this.$timeout(() => {
        this.displayMessageForJobbler(job, type);
      });
    }
  }

  sendToPartnerPostUrl(job, type) {
    console.log("sendToPartnerPostUrl");
    console.dir(job);
    console.dir(type);

    if (this.currentUser || this.$localStorage.partnerEmail) {
      this.setPartnersPostsInteraction(job);
      const url = job.url || job.partnerPostContent.url || job.partnerPostContent.cm_url || "/jobs";
      this.$window.open(url);
    } else {
      this.$rootScope.$emit("SetApplyProfileJob", {job});
      $("#apply-profile-modal").modal("toggle");
    }
  }

  getQuestionsReadyForApply(job) {
    this.$timeout(() => {
      this.$rootScope.$emit("ClearApplicationQuestions", {data: job});
    });

    this.$timeout(() => {
      $("#apply-profile-modal").modal();
    }, 100);

    this.$timeout(() => {
      this.$rootScope.$emit("SetApplicationQuestions", {data: job});
    }, 500);
  }

  closeVerificationModal() {
    this.$timeout(() => {
      $("#user-not-verified").modal("hide");
    });
    this.$timeout(() => {
      $("#apply-profile-modal").modal();
    }, 500);
  }

  displayMessageForJobbler(job, type) {
    let user = this.currentUser;

    if (user) {
      if (!user.isVerified) {
        this.setLoader();
        this.$profile.checkValidationStatus().then(
          (response) => {
            this.unSetLoader();
            if (response.data.isVerified === false) {
              this.$timeout(() => {
                $("#apply-profile-modal").modal();
                this.$rootScope.$emit("SetDataForVerification", {job, user});
              });
            } else {
              this.currentUser.isVerified = true;
              this.checkBasicProfileStatus(user);
            }
          },
          (error) => {
            this.unSetLoader();
          }
        );
      } else {
        this.checkBasicProfileStatus(user, job);
      }
    } else {
      this.$timeout(() => {
        $("#apply-profile-modal").modal();
        this.$rootScope.$emit("SetApplicationQuestions", {
          data: job,
          user_ready: false,
          button_type: type,
        });
      });
    }
  }

  checkBasicProfileStatus(user, job) {
    if (!this.userReady) {
      this.$timeout(() => {
        this.$rootScope.$emit("SetDataForVerification", {user, job});
        $("#apply-profile-modal").modal();
      });
    }
  }

  setLoader() {
    this.$timeout(() => {
      $("html").addClass("wait");
    });
  }

  unSetLoader() {
    this.waiting_for_last = false;
    this.bottom_loading = false;
    this.$timeout(() => {
      $("html").removeClass("wait");
    });
  }

  loadMore() {
    let max = 10;
    let offset = this.jobs.length;

    let queryParams = this.boardParams;
    queryParams.max = max;
    queryParams.offset = offset;

    this.loadJobsPOST(queryParams, true);
  }

  canUserApplyToShiftBasedJobs() {
    const currentUser = this.$auth.getUserData();
    this.userReady = this.validateUserPrefs(currentUser);
    this.profileStatus = this.$profile.getUserProfileStatus(currentUser);
  }

  validateUserPrefs(user) {
    this.userReady = !(
      !user.dateBirth ||
      !user.homeContactInfo.phoneMobile ||
      !user.ssn ||
      !user.profilePictureUri ||
      !user.homeContactInfo.zipCode ||
      !user.homeContactInfo.city ||
      !user.homeContactInfo.streetLine1 ||
      !user.homeContactInfo.state
    );

    return this.userReady;
  }

  setJobForBackButton(job, index) {
    var _this = this;

    this.trackViewJobFromBoard(job);
    this.$rootScope.anchor = "job-label-" + index;

    let url_data = {};
    url_data.src = "internal";
    url_data.job_listings = "true";

    if (_this.currentUser) {
      let data = _this.$iterable.set_data(_this.boardParams, job, _this.currentUser, "view");
      _this.track_jobble_view(data);
    }
    if (_this.boardParams.company || _this.boardParams.search) {
      url_data.company_ph = _this.boardParams.company;
      url_data.search_ph = _this.boardParams.search;
      url_data.zipcode_ph = _this.boardParams.zipcode;
    } else {
      url_data.zipcode_ph = _this.boardParams.zipcode;
    }
    _this.$location.path("/job/" + job.id).search(url_data);
  }

  track_jobble_view(data) {
    var _this = this;
    _this.$iterable.track_jobble_view(data).then(
      function (response) {},
      function (error) {}
    );
  }

  trackBoardLoad() {
    var _this = this;
    let data = {};

    if (!_this.currentUser) {
      data.username = "Unregistered";
    } else {
      data.username = _this.currentUser.username;
    }
    if (_this.boardParams && _this.boardParams.zipcode) {
      data.zipcode = _this.boardParams.zipcode;
    }
    if (_this.boardParams && _this.boardParams.placeRef) {
      data.placeRef = _this.boardParams.placeRef;
    }
    _this.$tracking.reportJobBoardLoad(data);
  }

  formatAndSyncQueryParams(queryParams) {
    if (angular.isUndefined(queryParams.geoFenceRadius)) {
      queryParams.geoFenceRadius = 40;
    }

    if (this.filter.radius_change) {
      queryParams.geoFenceRadius = this.$jobs.milesToKilometers(queryParams.geoFenceRadius);
    }

    this.boardParams = queryParams;
    this.placeParamsInURL(queryParams);
    this.$rootScope.boardParameters = queryParams;
    console.log("EMITTING", queryParams);

    this.$rootScope.$emit("JobSearchQueryParams", queryParams);

    this.$timeout(() => {
      this.unSetLoader();
    }, 3000);

    return queryParams;
  }

  loadJobsPOST(queryParams, loadingMore) {
    if (!loadingMore) {
      this.jobs = [];
      this.filteredJobs = [];
      this.filteredRelevantJobs = [];
      this.filteredFillInJobs = [];
    }

    queryParams = this.formatAndSyncQueryParams(queryParams);

    if (queryParams.zipcode) {
      this.$localStorage.zipCode = queryParams.zipcode;
    }

    console.log(this.boardParams);

    this.setLoader();
    this.jobs_loading = true;
    this.no_more_jobs_with_this_search = false;
    this.no_zip_code = false;

    console.time("Load Jobs Time End:");

    const params = _.cloneDeep(queryParams);

    params.jobbleTypes = [];
    params.search = params.search || "";

    if (params.jobbleTypeNames && params.jobbleTypeNames.length) {
      let query = params.search ? [params.search.toLowerCase()] : [];
      params.search = [...query, ...params.jobbleTypeNames];
      params.search = params.search.join(",");
      params.jobbleTypeNames = undefined;
    }

    console.log(params);

    clearTimeout(this.searchTimeout);

    this.searchTimeout = setTimeout(() => {
      this.$jobs.getJobsPOST(params).then(
        (response) => {
          this.unSetLoader();

          console.log("jobs response");
          console.dir(response);

          if (response.data.status === "error") {
            this.jobs_loading = false;
            this.handleError(response, loadingMore);
            return;
          } else {
            this.system_error = false;
          }

          if (loadingMore) {
            this.hideLoadingMoreBanner();
          }

          const results = response.data.data;
          const suggestionFilters = response.data.suggestions && response.data.suggestions.length ? response.data.suggestions : [];

          this.$rootScope.$emit("DynamicSuggestedFilters", suggestionFilters);

          if (loadingMore && results.length === 0) {
            console.warn("No more jobs with this search is: true");
            this.no_more_jobs_with_this_search = true;
            return;
          }

          this.processJobs(results, loadingMore, queryParams).then((jobs) => {
            this.applyFilters(jobs);

            const search = this.$location.search();

            console.log(this.selectedJob, this.hasInitialSelectedJob);

            if (this.selectedJob && this.hasInitialSelectedJob) {
              this.hasInitialSelectedJob = false;
            } else if (!this.selectedJob && this.filteredJobs && this.filteredJobs.length) {
              if (search.jid) {
                this.filteredJobs.forEach((job) => {
                  if (job.id + "" === search.jid + "") {
                    this.setSelectedJob(job);
                  }
                });

                if (!this.selectedJob) {
                  this.setSelectedJob(
                    this.filteredRelevantJobs && this.filteredRelevantJobs.length ? this.filteredRelevantJobs[0] : this.filteredJobs[0]
                  );
                }
              } else {
                this.setSelectedJob(
                  this.filteredRelevantJobs && this.filteredRelevantJobs.length ? this.filteredRelevantJobs[0] : this.filteredJobs[0]
                );
              }
            } else if (this.selectedJob && !loadingMore && this.filteredJobs) {
              let searchArray = this.filteredJobs;
              if (this.filteredRelevantJobs && this.filteredRelevantJobs.length) searchArray = this.filteredRelevantJobs;

              let found = false;
              searchArray.forEach((job) => {
                if (job.id === this.selectedJob.id) found = true;
              });

              if (!found) {
                this.setSelectedJob(
                  this.filteredRelevantJobs && this.filteredRelevantJobs.length ? this.filteredRelevantJobs[0] : this.filteredJobs[0]
                );
              }
            }
          });

          this.trackBoardLoad();
        },
        (error) => {
          console.error(error);
          this.unSetLoader();
          if (loadingMore) {
            this.hideLoadingMoreBanner();
          }
          let errorStr = error.toString();
          if (errorStr.indexOf("Data must be a valid JSON") > -1) {
            this.handleBadJson(error, null);
          } else {
            this.jobs_loading = false;
            this.system_error = true;
          }
        }
      );
    }, 1000);
  }

  handleError(response, loadingMore) {
    console.error(response);
    this.system_error = true;
    if (loadingMore) {
      this.hideLoadingMoreBanner();
    }
  }

  trackViewJobFromBoard(job) {
    var _this = this;
    let data = {};
    if (!_this.currentUser) {
      data.username = "Unregistered";
    } else {
      data.username = _this.currentUser.username;
    }
    _this.$tracking.reportViewJobFromJobBoard(data);

    if (job && job.is_partner_post) {
      _this.$analytics.trackClickCMJob();
    }
  }

  trackApplyToJobFromBoard(job) {
    var _this = this;
    let data = {};
    if (!_this.currentUser) {
      data.username = "Unregistered";
    } else {
      data.username = _this.currentUser.username;
      if (job.partnerPostContent) {
        _this.setPartnersPostsInteraction(job);
      }
    }
    _this.$tracking.reportApplyToJobFromBoard(data);

    if (job && job.is_partner_post) {
      _this.$analytics.trackClickCMJob(job);
    }
  }

  setPartnersPostsInteraction(job) {
    this.$jobs.setPartnersPostsInteraction(job).then(
      (response) => {},
      (error) => {}
    );
  }

  handleBadJson(error, job) {
    this.jobs_loading = false;
    this.jobs = [];
    this.relevantJobs = [];
    this.fillInJobs = [];
    this.filteredJobs = [];
    this.filteredRelevantJobs = [];
    this.filteredFillInJobs = [];
    let params = {};
    params.zipcode = this.boardParams.zipcode;
    params.geoFenceRadius = this.boardParams.geoFenceRadius;
    params.offset = this.boardParams.offset;
    this.$tracking.reportJobbleBoardFailedJson(params);
  }

  setSort() {
    let queryParams = this.boardParams;
    queryParams.offset = 0;

    if (this.sort === "relevance") {
      queryParams.sort = undefined;
    } else {
      queryParams.sort = {
        name: this.sort,
        value: this.sort === "startTime" ? "asc" : "desc",
      };
    }

    this.$tracking.reportClickJobSort("job board", this.sort);

    this.loadJobsPOST(queryParams);
  }

  setJobParamsForSearch() {
    const queryParams = {
      max: 10,
      type: "text_search",
      sort: {
        name: "startTime",
        value: "asc",
      },
      geoFenceRadius: 40,
    };

    queryParams.search = this.$location.$$search.q || undefined;
    queryParams.zipcode = this.$location.$$search.z || this.$stateParams.zipcode || this.$localStorage.zipCode || undefined;

    console.log("Local storage zip code:", this.$localStorage.zipCode);
    return queryParams;
  }

  loadMoreJobs() {
    // TODO: Get Infinite scrolling working . . .
    console.log("LOAD MORE");

    if (this.waiting_for_last) return;

    console.error("Loading New Jobs");

    this.waiting_for_last = true;

    if (!this.no_more_jobs_with_this_search) this.loadMoreJobsFromBottom();
  }

  loadMoreJobsFromBottom() {
    if (!this.jobs_loading) {
      this.bottom_loading = true;
    } else {
      this.waiting_for_last = false;
      return;
    }

    if (this.jobs && this.jobs.length > 0 && this.bottom_loading) {
      this.displayLoadingMoreBanner();
      this.loadMore();
    } else {
      this.bottom_loading = false;
      console.error("OPther case");
      this.waiting_for_last = false;
    }
  }

  displayLoadingMoreBanner() {
    this.$timeout(() => {
      $(".jobs-complete-container .container .load-more-loader-jobs-scroll").show("slide", {direction: "down"}, 100);
    });
  }

  hideLoadingMoreBanner(no_more_jobs) {
    this.$timeout(() => {
      $(".jobs-complete-container .container .load-more-loader-jobs-scroll").hide("slide", {direction: "up"}, 100);
    });

    this.$timeout(() => {
      this.jobs_loading = false;
    });
  }

  closeIndiBanner() {
    this.$timeout(() => {
      $(".indi-jobble-holder").hide("slide", {direction: "up"}, 100);
    });
  }

  isCurrentUser() {
    if (this.currentUser) {
      this.$window.Intercom("boot", {
        app_id: "och30e8r",
        email: this.currentUser.email,
        user_id: this.currentUser.id,
        created_at: 1234567890,
      });
    }
  }
}

JobsController.$inject = [
  "$window",
  "$location",
  "$http",
  "$localStorage",
  "$state",
  "auth",
  "events",
  "security",
  "$stateParams",
  "$timeout",
  "$interval",
  "$rootScope",
  "$scope",
  "jobs",
  "$anchorScroll",
  "tracking",
  "profile",
  "iterable",
  "analytics",
];

export default JobsController;



// WEBPACK FOOTER //
// ./client/app/components/jobs/jobs.controller.js